export default __webpack_public_path__ + "static/media/feature-2.1e13d8d9.webp";